import AsyncStorage from '@react-native-async-storage/async-storage';
import {useEffect, useState} from 'react';
import webviewUrl, {WEBVIEW_STAGE} from '../env/webviewUrl';
import {getObjectKey} from '../utils/stroge';

const storageKey = 'webviewUrlEnvConfig';

export function useDevConfigKey() {
  const [config, setConfig] = useState<Record<string, any> | null>(null);
  useEffect(() => {
    (async () => {
      const initValue = {
        CMSWebview: WEBVIEW_STAGE,
        AI: WEBVIEW_STAGE,
        DevSetting: 0,
      };
      const webviewUrlEnvConfig = (await getObjectKey(storageKey)) || initValue;
      setConfig(webviewUrlEnvConfig);
    })();
  }, []);

  useEffect(() => {
    if (config) {
      AsyncStorage.setItem(storageKey, JSON.stringify(config));
    }
  }, [config]);
  const setConfigKey = async (key: string, value: any) => {
    setConfig({
      ...config,
      [key]: value,
    });
  };

  return {
    config,
    setConfigKey,
    getUrl(key: string): Record<string, any> | string {
      // @ts-ignore
      return config ? webviewUrl[key][config[key]] : '';
    },
  };
}
